import GuideOpenTripCard from "components/TripCard/GuideOpenTripCard";
import { getGuideOpenTrip } from "functions/redux/listing/action";
import { RootStore } from "functions/redux/store";
import { useEffect } from "react";
import Loader from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";

const OpenTripListGuide = () => {
    const { listing } = useSelector((state: RootStore) => state);
    const dispatch = useDispatch();
    useEffect(() => {
        if (listing.guideOpenTripList == null) {
            dispatch(getGuideOpenTrip());
        }
    }, [listing, listing.guideOpenTripList])

    return (<>
        <div className="mt-8 grid grid-cols-1 gap-6 md:gap-7 sm:grid-cols-2">
            {listing.guideOpenTripList && (listing.guideOpenTripList).map((stay: IProduct) => (
                <GuideOpenTripCard key={stay.id} data={stay} />
            ))}
        </div>
        <div className="flex mt-11 justify-center items-center">
            {listing.guideOpenTripList == null &&
                <Loader
                    type="Circles"
                    color="#d24e29"
                    height={25}
                    width={25}
                />}
        </div>
    </>);
}

export default OpenTripListGuide;